export class ScrapbookUtils {
  static DEFAULT_SPACING: number = 40;
  static DEFAULT_PAGE_WIDTH: number = 800;
  static DEFAULT_PAGE_HEIGHT: number = 600;
  static DEFULAT_SECTION_COLOR: string = '#007bff';
}
